<template>
  <div class="loading-box" v-if="loading">
    <a-spin size="large" class="loading-spin" />
  </div>
  <div class="buddhism-detail flex-box vertical" v-else-if="info">
    <buddha-detail class="buddha-detail-area" ref="buddhaDetail" :info="info"></buddha-detail>
    <buddhism-registration ref="registration" :info="info" class="buddhism-registration"></buddhism-registration>
  </div>
</template>

<script>
import * as buddhism from "../../../../../common/buddha/buddhism";
import BuddhaDetail from "../../../../../layouts/BuddhaDetail";
import { getLunarDay } from "../../../../../components/calendar/lunar";
import BuddhismRegistration from "../../../../../layouts/buddha/BuddhismRegistrationInfo";

export default {
  name: "BuddhismDetail",
  components: {
    BuddhaDetail,
    BuddhismRegistration,
  },
  props: {
    id: { type: String },
  },
  data() {
    return {
      buddhism,
      info: null,
      loading: false,
    };
  },
  watch: {
    id() {
      this.getDetail();
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    getLunarDay,
    getDetail() {
      let id = this.id;
      if (!id || this.loading) return;
      this.loading = true;
      let url = `/admin/fs/${id}?expand=master,temp,order,tablet,evaluateUser,timeRange,palaceInfo`;
      this.$axios(url)
        .then(this.dealInfo)
        .finally(() => {
          this.loading = false;
        });
    },
    dealInfo(info) {
      buddhism.dealBuddhism(info);
      this.info = info;
    },
  },
};
</script>

<style scoped lang="less">
.buddhism-detail {
  position: relative;
  padding-bottom: 0;
}
.loading-spin {
  color: var(--primary-color);
}
:deep(.buddha-detail-area) {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 24px;
  .other-title {
    font-size: 20px;
    .buddha-detail-text {
      color: rgba(255, 255, 255, 0.8);
    }
  }
  .buddha-detail-item {
    font-size: 16px;
    .buddha-detail-label {
      color: #fff;
    }
    .buddha-detail-text {
      color: #f9e6b3;
    }
  }
  .buddha-tablet-item {
    background-color: rgba(242, 204, 0, 0.15);
    border: 1px solid #d4b26a;
    .buddha-tablet-label {
      color: rgba(255, 255, 255, 0.8);
    }
    .buddha-tablet-text {
      color: #f9e6b3;
    }
  }
  .ant-timeline-item {
    color: #fff;
    .ant-timeline-item-head-blue {
      color: var(--primary-color);
      border-color: var(--primary-color);
    }
  }
}
.buddhism-registration {
  display: none;
}
</style>
